// Eligibility API returns lowercase provider names — see
// Tenant/Domain/Payroll/Eligibility/EligibilityService::getPayrollProvider
const AU_PROVIDERS: ReadonlyArray<string> = ['microkeeper', 'microkeeperbeta'];
const US_PROVIDERS: ReadonlyArray<string> = ['paycor'];

export function isAUProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return AU_PROVIDERS.includes(provider.toLowerCase());
}

export function isUSProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return US_PROVIDERS.includes(provider.toLowerCase());
}
